import React, { createContext, useContext, useState, useCallback, useMemo } from "react";
import FlashMessageContainer from "../components/Flashmessage/FlashMessageContainer";

const FlashContext = createContext();

export function FlashProvider({ children }) {
    const [flash, setFlash] = useState({ message: "", type: "success" });

    const showFlash = useCallback((message, type = "success") => {
        setFlash({ message, type });
    }, []);

    const clearFlash = useCallback(() => {
        setFlash({ message: "", type: "" });
    }, []);

    // ✅ Memoize context value
    const value = useMemo(() => ({ showFlash }), [showFlash]);

    return (
        <FlashContext.Provider value={value}>
            {children}
            {flash.message && (
                <FlashMessageContainer
                    message={flash.message}
                    type={flash.type}
                    onClose={clearFlash}
                />
            )}
        </FlashContext.Provider>
    );
}

export function useFlash() {
    const context = useContext(FlashContext);
    if (!context) {
        throw new Error('useFlash must be used within a FlashProvider');
    }
    return context;
}
